import { render, staticRenderFns } from "./MinisiteDeclareResult.vue?vue&type=template&id=3acce05f&"
import script from "./MinisiteDeclareResult.vue?vue&type=script&lang=js&"
export * from "./MinisiteDeclareResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3acce05f')) {
      api.createRecord('3acce05f', component.options)
    } else {
      api.reload('3acce05f', component.options)
    }
    module.hot.accept("./MinisiteDeclareResult.vue?vue&type=template&id=3acce05f&", function () {
      api.rerender('3acce05f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MinisiteDeclareResult.vue"
export default component.exports